export default (store) => ({
  path: 'games',
  getIndexRoute(nextState, callback) {
    require.ensure([], (require) => callback(null, { component: require('./containers/ListContainer').default }));
  },
  getChildRoutes(location, callback) {
    // do asynchronous stuff to find the child routes
    require.ensure([], (require) => {
      const routes = require('./routes').default(store);
      callback(null, routes);
    });
  },
});



// WEBPACK FOOTER //
// ./src/routes/games/index.js